import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Drives the full-screen WorldTumbler logo intro shown right after sign-in.
 * `play()` resolves once the intro has finished (or been skipped), so callers
 * can chain follow-up UI such as the beta announcement modal.
 */
@Injectable({
  providedIn: 'root'
})
export class IntroService {
  private _active = new BehaviorSubject<boolean>(false);
  public readonly active$ = this._active.asObservable();

  private pending: Promise<void> | null = null;
  private resolvePending: (() => void) | null = null;

  play(): Promise<void> {
    if (this.pending) {
      return this.pending;
    }
    this.pending = new Promise<void>((resolve) => (this.resolvePending = resolve));
    this._active.next(true);
    return this.pending;
  }

  finish() {
    if (!this.pending) {
      return;
    }
    this._active.next(false);
    this.resolvePending?.();
    this.pending = null;
    this.resolvePending = null;
  }
}
